export default "__VITE_ASSET__32de643d__"